import XHR from '@/request/http'
const $h = new XHR()
// url
const url = {
    lists:'/admin/v1/keypoint/page',
    update:'/admin/v1/keypoint/update',
    create:'/admin/v1/keypoint/create',
    del:'/admin/v1/keypoint/del',
    get:'/admin/v1/keypoint/get',
    match:'/admin/v1/keypoint/match'
}


export async function lists(data)
{
    return $h.request(url.lists,data,'GET')
}

export async function create(data)
{
    return $h.request(url.create,data,'POST')
}

export async function update(data)
{
    return $h.request(url.update,data,'POST')
}

export async function del(data)
{
    return $h.request(url.del,data,'POST')
}

export async function get(id)
{
    return $h.request(url.get,{id:id},'GET')
}

export async function match(textContent)
{
    return $h.request(url.match,{textContent:textContent},'POST')
}
